import { IThemeConfigOverrides } from './theme';
import { themeSetUp } from './themeUtils';
import { THEMES } from '@cmctechnology/webinvest-constants';

const themeConfigOverrides: IThemeConfigOverrides = {
  publicSiteConfig: {
    variant: 'accent',
    backgroundImage: '/l/cmcsingapore/login/b.jpg',
    watermarkImage: '/l/cmcsingapore/login/w.svg'
  }
};

const componentOverrides = {};

export const cmcSingaporeTheme = themeSetUp(THEMES.CMCSingapore, false, themeConfigOverrides, componentOverrides);
export const cmcSingaporeDarkTheme = themeSetUp(THEMES.CMCSingapore, true, themeConfigOverrides, componentOverrides);
